define('modules/accounts/status/products/mdirector/balance/transfer/resume/view',['require','exports','module','views/BaseView','jquery','../result/view','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");
    var $ = require("jquery");
    var ResultView = require("../result/view");

    var View = BaseView.extend({
        template: require("ldsh!./template"),
        events: {
            "click #confirm": "transferenceConfirmed"
        },
        serialize: function() {
            return {
                group: this.group,
                model: this.model,
                balance: this.balance
            };
        },
        transferenceConfirmed: function() {
            this.resultView = new ResultView({
                el: "#transfer-modal-body",
                model: this.model,
                balance: this.balance,
                responseOk: true
            });

            if (this.model.get("field") === "sms_country") {
                this.model.set("value", this.model.get("value") + "->" + this.model.get("country"));
            }

            var self = this;
            this.model.save(null, {
                success: function(model, response){
                    if (response.response === "ko") {
                        self.resultView.setResponseOk(false);
                    }
                }
            });
        }
    });
    module.exports = View;
});

